import { render, staticRenderFns } from "./realEstateTodo.vue?vue&type=template&id=8aae7912&"
import script from "./realEstateTodo.vue?vue&type=script&lang=js&"
export * from "./realEstateTodo.vue?vue&type=script&lang=js&"
import style0 from "./realEstateTodo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports